/* The Mergilo Letter popup: trigger, timing, dismissal and Klaviyo subscription. Markup and styles live in sections/mergilo-letter-popup.liquid. */
(function () {
  var root = document.getElementById('mergilo-letter');
  if (!root || root.__mlp) return;
  root.__mlp = true;
  // Live directly under <body> so no theme stacking context can put the cart drawer above it
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var DELAY_MS = 3000;      // after the cart drawer has finished opening
  var FADE_MS = 700;        // opacity 0 -> 1, matches the CSS transition
  var DISMISS_DAYS = 30;
  var KEY = 'mergilo_letter';
  var SESSION_KEY = 'mergilo_letter_shown';
  var productId = String(root.getAttribute('data-product-id'));
  var handle = root.getAttribute('data-product-handle');
  var variantIds = (root.getAttribute('data-variant-ids') || '').split(',');
  var companyId = root.getAttribute('data-company-id');
  var listId = root.getAttribute('data-list-id');
  var dialog = root.querySelector('.mlp-dialog');
  var form = root.querySelector('[data-mlp-form]');
  var input = root.querySelector('#mlp-email');
  var errorEl = root.querySelector('[data-mlp-error]');
  var submitBtn = root.querySelector('.mlp-submit');
  var state = 'idle'; // idle -> armed -> shown -> closed
  var matchedId = productId;
  var lastFocus = null;
  var mq = window.matchMedia('(max-width: 899px)');
  // Inside the Shopify theme editor only: never suppress, so every Ciel add replays it
  var editor = !!(window.Shopify && window.Shopify.designMode);

  function store(k, v, s) { try { (s || localStorage).setItem(k, v); } catch (e) {} }
  function read(k, s) { try { return (s || localStorage).getItem(k); } catch (e) { return null; } }

  try { if (/[?&]_kx=/.test(location.search)) store(KEY, JSON.stringify({ s: 'subscribed', t: Date.now() })); } catch (e) {}

  function suppressed() {
    if (editor) return false;
    if (read(SESSION_KEY, sessionStorage)) return true;
    var v = read(KEY);
    if (!v) return false;
    try {
      var o = JSON.parse(v);
      if (o.s === 'subscribed') return true;
      if (o.s === 'dismissed' && Date.now() - o.t < DISMISS_DAYS * 864e5) return true;
    } catch (e) {}
    return false;
  }

  function isCiel(data, body) {
    try {
      var items = data && (data.items || (data.product_id ? [data] : []));
      if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (String(it.product_id) === productId || it.handle === handle || /^ciel sneaker$/i.test(String(it.product_title || '').trim())) {
            matchedId = String(it.product_id || productId); return true;
          }
        }
        return false;
      }
    } catch (e) {}
    // Fallback: inspect the request body for a Ciel variant id
    try {
      var ids = [];
      if (body instanceof FormData) { ids = body.getAll('id').concat(body.getAll('items[][id]')); }
      else if (typeof body === 'string') {
        if (body.charAt(0) === '{') { var j = JSON.parse(body); ids = j.items ? j.items.map(function (x) { return x.id; }) : [j.id]; }
        else { var p = new URLSearchParams(body); ids = p.getAll('id').concat(p.getAll('items[][id]')); }
      }
      for (var k = 0; k < ids.length; k++) if (variantIds.indexOf(String(ids[k])) > -1) { matchedId = productId; return true; }
    } catch (e) {}
    return false;
  }

  function isAddUrl(u) { return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(u || '')); }

  // Watch every add-to-cart request (product form, drawer upsell, apps)
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = nativeFetch.apply(this, arguments);
      if (isAddUrl(url) && state === 'idle') {
        var body = init && init.body;
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (d) { if (isCiel(d, body)) arm(); }, function () { if (isCiel(null, body)) arm(); });
        }, function () {});
      }
      return p;
    };
  }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__mlpAdd = isAddUrl(u); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (xhr.__mlpAdd && state === 'idle') {
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        var d = null; try { d = JSON.parse(xhr.responseText); } catch (e) {}
        if (isCiel(d, body)) arm();
      });
    }
    return xs.apply(this, arguments);
  };

  function preload() {
    var img = root.querySelector(mq.matches ? '.mlp-img-m' : '.mlp-img-d');
    var src = root.getAttribute(mq.matches ? 'data-img-mobile' : 'data-img-desktop');
    if (img && !img.getAttribute('src')) img.setAttribute('src', src);
  }

  // Fit the popup to the screen without changing its design: it is scaled uniformly.
  // Mobile: scaled to the width of the open cart drawer's frame (top edge aligned with
  // the frame); if that makes it taller than the screen, the popup scrolls.
  // Desktop: shown at full size, scaled down only if the window is too short.
  var spacer = null;
  var vv = window.visualViewport || null;
  var frame = null;   // mobile geometry from the last fit with the keyboard closed
  var restVh = 0;     // visible height the last time the keyboard was closed
  var EXTRA = 180;    // px the popup layer runs on past the visible area on mobile
  // On a phone the area the browser reports as visible stops above Safari's collapsed
  // toolbar and the keyboard's accessory bar, yet the page still shows through behind
  // both. So on mobile the popup layer tracks the visible area and runs on past its
  // bottom edge; the extra is hidden behind the keyboard, or off screen, and nothing
  // behind the popup can be seen while typing.
  function visibleH() { return vv ? vv.height : window.innerHeight; }
  function typing() { return mq.matches && document.activeElement === input; }
  function kbOpen() { return typing() && restVh - visibleH() > 100; }
  function placeLayer() {
    var overlay = root.querySelector('.mlp-overlay');
    if (mq.matches) {
      var t = Math.round(vv ? vv.offsetTop : 0) + 'px', h = Math.round(visibleH() + EXTRA) + 'px';
      root.style.top = t; root.style.height = h; root.style.bottom = 'auto';
      if (overlay) {
        // while typing, everything around the popup is the popup's own colour, and the
        // backdrop runs down behind the whole (see-through) keyboard to the screen's foot
        var kb = kbOpen();
        overlay.style.top = t; overlay.style.bottom = 'auto';
        overlay.style.height = kb ? Math.round(visibleH() + Math.max(EXTRA, (window.screen && screen.height) || 0, window.innerHeight)) + 'px' : h;
        overlay.style.background = kb ? '#0d1719' : '';
      }
    } else {
      root.style.top = ''; root.style.height = ''; root.style.bottom = '';
      if (overlay) { overlay.style.top = ''; overlay.style.height = ''; overlay.style.bottom = ''; overlay.style.background = ''; }
    }
  }
  // While typing, keep the small print under the button (the bottom of the form) just
  // above the visible edge, so field, button and small print all sit above the keyboard
  function keepFormVisible() {
    if (!kbOpen()) return;
    var rr = root.getBoundingClientRect();
    var foot = root.querySelector('[data-mlp-form] .mlp-small:last-child') || submitBtn || input;
    var fb = foot.getBoundingClientRect().bottom;
    var limit = rr.top + visibleH() - 8;
    if (fb > limit) root.scrollTop += fb - limit;
    var it = input.getBoundingClientRect().top;
    if (it < rr.top + 8) root.scrollTop -= rr.top + 8 - it;
  }
  function fit() {
    dialog.style.transform = '';
    dialog.style.maxHeight = 'none';
    dialog.style.top = ''; dialog.style.left = ''; dialog.style.right = ''; dialog.style.margin = ''; dialog.style.width = '';
    dialog.style.height = '';
    root.style.overflowY = ''; root.style.overscrollBehavior = '';
    var overlay = root.querySelector('.mlp-overlay');
    if (overlay) overlay.style.position = '';
    if (spacer) spacer.style.display = 'none';
    placeLayer();
    var vh = visibleH();
    var keyboard = kbOpen() && !!frame;   // decided before restVh is refreshed
    if (!keyboard) restVh = vh;
    if (mq.matches) {
      var vw = document.documentElement.clientWidth || window.innerWidth;
      var left = 6, width = vw - 12, top = 6, bottomGap = 6;
      if (keyboard) {
        // keyboard open: keep the popup exactly where it was and let it scroll
        left = frame.left; width = frame.width; top = frame.top; bottomGap = frame.bottomGap;
      } else {
        var drawer = document.getElementById('site-cart-sidebar');
        var box = drawer && drawer.classList.contains('sidebar--opened') && (drawer.querySelector('.sidebar__container') || drawer);
        if (box) {
          var r = box.getBoundingClientRect();
          if (r.width > 200 && r.height > 200) { left = r.left; width = r.width; top = Math.max(0, r.top); if (r.bottom <= vh) bottomGap = vh - r.bottom; }
        }
      }
      dialog.style.width = '378px';        // the approved mobile layout, unchanged
      dialog.style.height = 'auto';
      dialog.style.margin = '0';
      dialog.style.right = 'auto';
      dialog.style.left = Math.round(left) + 'px';
      dialog.style.top = Math.round(top) + 'px';
      dialog.style.transformOrigin = '0 0';
      var s = width / 378;
      dialog.style.transform = 'scale(' + s.toFixed(4) + ')';
      // On screens taller than the popup, centre it vertically; otherwise keep it at
      // the frame's top edge and let it scroll past the bottom of the screen
      var scaledH = dialog.offsetHeight * s;
      if (!keyboard && top + scaledH + bottomGap <= vh) {
        top = Math.max(0, (vh - scaledH) / 2);
        dialog.style.top = Math.round(top) + 'px';
      }
      if (!keyboard) frame = { left: left, width: width, top: top, bottomGap: bottomGap };
      var bottom = top + scaledH + bottomGap;
      root.style.overflowY = bottom > vh ? 'auto' : '';
      root.style.overscrollBehavior = 'contain';
      if (overlay) overlay.style.position = 'fixed';
      if (bottom > vh) {
        if (!spacer) { spacer = document.createElement('div'); spacer.setAttribute('aria-hidden', 'true'); spacer.style.cssText = 'position:absolute;left:0;width:1px;height:1px;pointer-events:none'; root.appendChild(spacer); }
        // the layer is EXTRA taller than the visible area, so the spacer sits EXTRA lower
        // to keep the same scroll range: the popup's bottom edge can still reach the screen's
        spacer.style.top = Math.ceil(bottom + EXTRA - 1) + 'px';
        spacer.style.display = 'block';
      }
    } else {
      dialog.style.transformOrigin = '50% 0';
      var room = vh - dialog.offsetTop - 12;
      var d = Math.min(1, room / dialog.offsetHeight);
      if (d < 1) dialog.style.transform = 'scale(' + d.toFixed(4) + ')';
    }
  }
  function refit() { if (state !== 'shown') return; var st = root.scrollTop; fit(); root.scrollTop = st; keepFormVisible(); }
  function refitSoon() { setTimeout(refit, 350); setTimeout(refit, 700); }
  window.addEventListener('resize', refit);
  if (vv) {
    vv.addEventListener('resize', refit);
    vv.addEventListener('scroll', function () { if (state === 'shown') placeLayer(); });
  }
  input.addEventListener('focus', refitSoon);
  input.addEventListener('blur', refitSoon);

  try { mq.addEventListener('change', function () { if (state === 'shown') preload(); }); } catch (e) {}

  function cielInDrawer(drawer) {
    var rows = drawer.querySelectorAll('[data-js-cart-item]');
    for (var i = 0; i < rows.length; i++) { var pid = String(rows[i].getAttribute('data-product-id')); if (pid === matchedId || pid === productId) return rows[i]; }
    return null;
  }

  // Wait until the cart drawer is open, has re-rendered with the Ciel line,
  // and its opening transition has finished (panel fully expanded and still).
  // Polls with setTimeout so it is independent of animation frames; time spent
  // with the tab in the background does not count toward the give-up limit.
  function whenDrawerReady(cb) {
    var waited = 0, last = null, stableSince = 0, openedAt = 0, STEP = 30;
    (function tick() {
      if (!document.hidden) waited += STEP;
      if (waited > 15000) { state = 'idle'; return; }
      var drawer = document.getElementById('site-cart-sidebar');
      var now = Date.now();
      if (!drawer || !drawer.classList.contains('sidebar--opened') || document.hidden) { stableSince = 0; openedAt = 0; last = null; return setTimeout(tick, STEP); }
      if (!openedAt) openedAt = now;
      var outer = drawer.getBoundingClientRect();
      var box = drawer.querySelector('.sidebar__container') || drawer;
      var r = box.getBoundingClientRect();
      var cs = getComputedStyle(drawer);
      var expanded = r.width > 0 && r.width >= outer.width - 2 && r.left < window.innerWidth && r.right > 0;
      var visible = expanded && cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.99;
      var sig = Math.round(r.left) + ',' + Math.round(r.width) + ',' + Math.round(r.top);
      if (visible && sig === last) { if (!stableSince) stableSince = now; } else { stableSince = 0; }
      last = sig;
      var row = cielInDrawer(drawer);
      var imgsDone = true;
      if (row) { var imgs = row.querySelectorAll('img'); for (var i = 0; i < imgs.length; i++) if (!imgs[i].complete) imgsDone = false; }
      if (visible && row && stableSince && now - stableSince >= 50 && (imgsDone || now - openedAt > 1500)) return cb();
      setTimeout(tick, STEP);
    })();
  }

  function arm() {
    if (state !== 'idle' || suppressed()) return;
    state = 'armed';
    preload();
    whenDrawerReady(function () {
      setTimeout(show, DELAY_MS);
    });
  }

  function show() {
    if (state !== 'armed' || suppressed()) { state = 'idle'; return; }
    if (document.hidden) { // wait for the visitor to come back so the fade is seen
      return document.addEventListener('visibilitychange', function once() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', once);
        show();
      });
    }
    state = 'shown';
    if (!editor) store(SESSION_KEY, '1', sessionStorage);
    preload();
    lastFocus = document.activeElement;
    root.classList.remove('mlp--in');
    root.hidden = false;
    frame = null;
    fit();
    root.scrollTop = 0;
    void root.offsetWidth; // commit opacity:0 before transitioning
    root.classList.add('mlp--in');
    try { dialog.focus({ preventScroll: true }); } catch (e) { dialog.focus(); }
    document.addEventListener('keydown', onKey, true);
    try { root.dispatchEvent(new CustomEvent('mergilo-letter:shown', { bubbles: true })); } catch (e) {}
  }

  function close() {
    if (state !== 'shown') return;
    state = editor ? 'idle' : 'closed';
    if (!editor && (read(KEY) === null || (function () { try { return JSON.parse(read(KEY)).s !== 'subscribed'; } catch (e) { return true; } })())) {
      store(KEY, JSON.stringify({ s: 'dismissed', t: Date.now() }));
    }
    document.removeEventListener('keydown', onKey, true);
    root.classList.remove('mlp--in');
    root.hidden = true;
    if (editor) {
      root.querySelector('[data-mlp-form-panel]').hidden = false;
      root.querySelector('[data-mlp-thanks-panel]').hidden = true;
      input.value = ''; errorEl.hidden = true;
    }
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function focusables() {
    return Array.prototype.filter.call(root.querySelectorAll('button, [href], input'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopImmediatePropagation(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (!root.contains(document.activeElement) || document.activeElement === dialog) { e.preventDefault(); (e.shiftKey ? lastEl : first).focus(); e.stopImmediatePropagation(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
      e.stopImmediatePropagation();
    }
  }

  // Keep clicks inside the popup from reaching the drawer's outside-click handlers
  ['click', 'mousedown', 'pointerdown', 'touchstart'].forEach(function (t) {
    root.addEventListener(t, function (e) {
      e.stopPropagation();
      if (t === 'click') { var c = e.target.closest && e.target.closest('[data-mlp-close]'); if (c) { e.preventDefault(); close(); } }
    }, t === 'touchstart' ? { passive: true } : false);
  });
  root.addEventListener('focusin', function (e) { e.stopPropagation(); });

  input.addEventListener('input', function () { errorEl.hidden = true; errorEl.textContent = 'Please enter a valid email address.'; });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = String(input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.hidden = false; input.focus(); return;
    }
    submitBtn.disabled = true;
    var payload = { data: { type: 'subscription', attributes: {
      custom_source: 'Mergilo Letter popup (Ciel add to cart)',
      profile: { data: { type: 'profile', attributes: {
        email: email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      } } }
    }, relationships: { list: { data: { type: 'list', id: listId } } } } };
    nativeFetch.call(window, 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2025-07-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('status ' + res.status);
      if (!editor) store(KEY, JSON.stringify({ s: 'subscribed', t: Date.now() }));
      root.querySelector('[data-mlp-form-panel]').hidden = true;
      var thanks = root.querySelector('[data-mlp-thanks-panel]');
      thanks.hidden = false;
      fit();
      try { root.querySelector('[data-mlp-thanks-title]').focus({ preventScroll: true }); } catch (err) {}
      try { root.dispatchEvent(new CustomEvent('mergilo-letter:subscribed', { bubbles: true })); } catch (err) {}
    }).catch(function () {
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.hidden = false;
    }).then(function () { submitBtn.disabled = false; });
  });
})();
